import { IconType } from "react-icons";
import { BiSolidBinoculars } from "react-icons/bi";
import { FaPiggyBank, FaScaleBalanced } from "react-icons/fa6";
import { MdTableChart, MdViewTimeline } from "react-icons/md";
import { TbChartDonutFilled } from "react-icons/tb";
import { PanelAmortization } from "./Loan/Main/PanelAmortization/PanelAmortization";
import { PanelHistoricals } from "./Loan/Main/PanelHistoricals/PanelHistoricals";
import { PanelOverview } from "./Loan/Main/PanelOverview/PanelOverview";
import { PanelProjections } from "./Loan/Main/PanelProjections/PanelProjections";
import { PanelROI } from "./Loan/Main/PanelROI/PanelROI";
import { PanelWorkingCapital } from "./WorkingCapital/PanelWorkingCapital/PanelWorkingCapital";

type PanelManifest = {
  path: string;
  icon: IconType;
  panel: React.ElementType;
  label: string;
  tabsTabProps?: Record<string, unknown>;
  sidebar?: React.ElementType;
};

export const panelManifest: PanelManifest[] = [
  {
    path: "historicals",
    icon: MdViewTimeline,
    panel: PanelHistoricals,
    label: "Historicals",
  },
  {
    path: "amortization",
    icon: MdTableChart,
    panel: PanelAmortization,
    label: "Amortization",
  },
  {
    path: "projections",
    icon: BiSolidBinoculars,
    panel: PanelProjections,
    label: "Projections",
  },
  {
    path: "roi",
    icon: TbChartDonutFilled,
    panel: PanelROI,
    label: "ROI Metrics",
  },
  {
    path: "overview",
    icon: FaPiggyBank,
    panel: PanelOverview,
    label: "Overview",
  },

  {
    path: "working-capital",
    icon: FaScaleBalanced,
    panel: PanelWorkingCapital,
    label: "Working Capital",
    tabsTabProps: {
      styles: {
        tab: {
          boxShadow: `rgb(10 37 64 / 12%) 6px 0px 9px 0px inset`,
          borderRadius: 0,
          borderLeftColor: "#bbbbbb",
          borderLeftStyle: "dotted",
          borderLeftWidth: 2,
          //backgroundColor: "#E7E8EA",
        },
      },
    },
  },
] as const;

//box-shadow: ;
